<template>
  <div class="guide" :class="{ inline }" @click.stop>
    <div class="head">
      <strong>积分说明</strong>
      <button v-if="!inline" type="button" class="x" @click="$emit('close')">关闭</button>
    </div>
    <p v-if="error" class="err">{{ error }}</p>
    <template v-else>
      <p class="label">可以获得</p>
      <ul>
        <li v-for="item in earn" :key="item.label">
          <span>{{ item.label }}</span>
          <b>+{{ item.points }}</b>
          <em>{{ item.note }}</em>
        </li>
      </ul>
      <p class="label">会消耗</p>
      <ul>
        <li v-for="item in spend" :key="item.label">
          <span>{{ item.label }}</span>
          <b class="minus">-{{ item.points }}</b>
          <em>{{ item.note }}</em>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { fetchCreditRules } from '../api/platformService'

export default {
  name: 'PointsGuide',
  props: {
    inline: { type: Boolean, default: false }
  },
  emits: ['close'],
  data() {
    return {
      error: '',
      earn: [],
      spend: []
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      try {
        const data = await fetchCreditRules()
        this.earn = data.earn || []
        this.spend = data.spend || []
      } catch (err) {
        this.error = '积分说明加载失败'
      }
    }
  }
}
</script>

<style scoped>
.guide.inline {
  position: static;
  width: auto;
  margin-top: 8px;
  padding: 0;
  border: 0;
  box-shadow: none;
}
.guide {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 320px;
  padding: 14px;
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(29, 33, 41, 0.12);
  z-index: 40;
  text-align: left;
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.head strong { font-size: 14px; }
.x {
  border: 0;
  background: transparent;
  color: #86909c;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
}
.label {
  margin: 8px 0 4px;
  font-size: 12px;
  color: #86909c;
}
ul { list-style: none; margin: 0; padding: 0; }
li {
  display: grid;
  grid-template-columns: 88px 36px 1fr;
  gap: 6px;
  align-items: baseline;
  padding: 5px 0;
  border-top: 1px solid #f2f3f5;
  font-size: 13px;
  color: #1d2129;
}
b { color: #188038; }
b.minus { color: #d3382c; }
em { color: #86909c; font-style: normal; font-size: 12px; }
.err { margin: 0; color: #d3382c; font-size: 13px; }
</style>
